const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/cutting-machines`,
    saveMakeReadyTable: `${API_URL}/cutting-machine/save-make-ready-table`,
};

export default apiUrls;
